import React from 'react'

type Props = {}

function Cancell({}: Props) {
  return (
    <div>Cancell</div>
  )
}

export default Cancell